// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__U5ocA"};